import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import ChevronForwardIcon from '../../../../static/icons/ic_chevron_forward_small_24.svg';
import * as Constants from '../../../constants';
import { isMobileWeb } from '../../../lib/CapabilitiesUtils';
import { curatorExperienceEnabled } from '../../../lib/configuration/TunerVarUtils';
import { createBEM } from '../../../lib/utils/css';
import Icon from '../../Icon/Icon';
import ButtonT3 from '../ButtonT3/ButtonT3';
import { ButtonT3Theme } from '../ButtonT3/constants';

import './ContentSection.scss';

export class ContentSection extends React.Component {
  static propTypes = {
    backgroundImgAlt: PropTypes.string,
    backgroundImgUrl: PropTypes.string,
    children: PropTypes.node,
    disableHover: PropTypes.bool,
    moreAction: PropTypes.func,
    moreText: PropTypes.node,
    moreTextOnclick: PropTypes.func,
    moreUrl: PropTypes.string,
    name: PropTypes.string,
    onSocialButtonClick: PropTypes.func,
    secondMoreText: PropTypes.node,
    sortDropdownMenu: PropTypes.element,
    stationCreatedFrom: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    titleRef: PropTypes.node,
    useDarkTheme: PropTypes.bool,

    isAbout: PropTypes.bool,
    isAlbumDescription: PropTypes.bool,
    isAllAlbums: PropTypes.bool,
    isAllSongs: PropTypes.bool,
    isAllThumbs: PropTypes.bool,
    isArtistEvents: PropTypes.bool,
    isArtistsOnThisStation: PropTypes.bool,
    isArtistStation: PropTypes.bool,
    isBio: PropTypes.bool,
    isCuratorExperienceEnabled: PropTypes.bool,
    isDescription: PropTypes.bool,
    isEditableDescription: PropTypes.bool,
    isFeaturedContent: PropTypes.bool,
    isFirstSection: PropTypes.bool,
    isFocusTraits: PropTypes.bool,
    isFullDescription: PropTypes.bool,
    isGridList: PropTypes.bool,
    isInline: PropTypes.bool,
    isLatestRelease: PropTypes.bool,
    isMobileWeb: PropTypes.bool,
    isPlayableRowGrid: PropTypes.bool,
    isPodcastDescription: PropTypes.bool,
    isPodcastEpisodeRowGrid: PropTypes.bool,
    isSimilarArtists: PropTypes.bool,
    isSimilarSongs: PropTypes.bool,
    isSnippet: PropTypes.bool,
    isSocial: PropTypes.bool,
    isSongsOnThisStation: PropTypes.bool,
  };

  renderMoreText = () => {
    if (!this.props.moreText) {
      return;
    }

    const classes = 'ContentSection__cta__link';
    if (this.props.moreAction) {
      return (
        <button className={classes} onClick={this.props.moreAction}>
          {this.props.moreText}
        </button>
      );
    }
    if (this.props.moreUrl) {
      return (
        <Link to={this.props.moreUrl} onClick={this.props.moreTextOnclick} className={classes}>
          <div className={'ContentSection__cta__text'}>
            {this.props.moreText}
            <span className='a11y--visuallyHidden'>{this.props.title}</span>
            {this.props.isMobileWeb && this.props.isCuratorExperienceEnabled && (
              <div className={'ContentSection__cta__secondText'}> {this.props.secondMoreText}</div>
            )}
          </div>
        </Link>
      );
    }
  };

  renderHeader = () => {
    if (!this.props.title && !this.props.moreText && !this.props.sortDropdownMenu) {
      return;
    }

    const titleClasses = createBEM('ContentSection__title', {
      useDarkTheme: this.props.useDarkTheme,
      hasBackgroundImg: !!this.props.backgroundImgUrl,
    });

    return (
      <header className='ContentSection__header'>
        {this.props.title && (
          <h2 ref={this.props.titleRef} className={titleClasses}>
            {this.props.title}
          </h2>
        )}
      </header>
    );
  };

  renderSocialSection = () => {
    if (!this.props.isSocial || this.props.isCuratorExperienceEnabled) return;

    return (
      <div>
        {/* ButtonT3 does NOT render under max-width: $break-width-min */}
        <div className='ContentSection__ctaButton'>
          <ButtonT3
            theme={ButtonT3Theme.LIGHT}
            onClick={this.props.onSocialButtonClick}
            iconType={'twitter'}
          >
            <FormattedMessage {...Constants.Backstage.messages.followOnTwitter} />
          </ButtonT3>
        </div>
        {/* RowItem renders under max-width: $break-width-min */}
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <div
          className='ContentSection__cta ContentSection__ctaButtonRow'
          onClick={this.props.onSocialButtonClick}
        >
          <div className='ContentSection__cta__link'>
            <FormattedMessage {...Constants.Backstage.messages.followOnTwitter} />
            <Icon className='chevronForwardIcon' glyph={ChevronForwardIcon} />
          </div>
        </div>
      </div>
    );
  };

  renderSortDropdownMenu = () => {
    return (
      this.props.sortDropdownMenu && (
        <div className='ContentSection__sortDropdownMenu'>{this.props.sortDropdownMenu}</div>
      )
    );
  };

  renderContent = () => {
    return (
      <React.Fragment>
        {this.renderHeader()}
        {this.props.sortDropdownMenu
          ? this.renderSortDropdownMenu()
          : this.props.moreUrl && this.renderMoreText()}
        {this.props.children}
        {this.renderSocialSection()}
      </React.Fragment>
    );
  };

  render() {
    const sectionClasses = createBEM('ContentSection', {
      about: this.props.isAbout,
      albumDescription: this.props.isAlbumDescription,
      allAlbums: this.props.isAllAlbums,
      allSongs: this.props.isAllSongs,
      allThumbs: this.props.isAllThumbs,
      artistEvents: this.props.isArtistEvents,
      artistsOnThisStation: this.props.isArtistsOnThisStation,
      artistStation: this.props.isArtistStation,
      bio: this.props.isBio,
      description: this.props.isDescription,
      disableHover: this.props.disableHover,
      editableDescription: this.props.isEditableDescription,
      featuredContent: this.props.isFeaturedContent,
      firstSection: this.props.isFirstSection,
      focusTraits: this.props.isFocusTraits,
      fullDescription: this.props.isFullDescription,
      gridList: this.props.isGridList,
      hasBackgroundImg: !!this.props.backgroundImgUrl,
      inline: this.props.isInline,
      latestRelease: this.props.isLatestRelease,
      noSeeMore: this.props.isMobileWeb && !this.props.moreUrl && !this.props.moreAction,
      playableRowGrid: this.props.isPlayableRowGrid,
      podcastDescription: this.props.isPodcastDescription,
      podcastEpisodeRowGrid: this.props.isPodcastEpisodeRowGrid,
      similarArtists: this.props.isSimilarArtists,
      similarSongs: this.props.isSimilarSongs,
      snippet: this.props.isSnippet,
      social: this.props.isSocial,
      songsOnThisStation: this.props.isSongsOnThisStation,
      stationCreatedFrom: this.props.stationCreatedFrom,
    });

    return !this.props.isMobileWeb && this.props.backgroundImgUrl ? (
      <section className={sectionClasses}>
        <img
          src={this.props.backgroundImgUrl}
          className='ContentSection__backgroundImg'
          alt={this.props.backgroundImgAlt}
        />
        <div className='ContentSection__contentWithBackgroundImg'>{this.renderContent()}</div>
      </section>
    ) : (
      <section className={sectionClasses}>{this.renderContent()}</section>
    );
  }
}

export function mapStateToProps(state) {
  return {
    isMobileWeb: isMobileWeb(state),
    isCuratorExperienceEnabled: curatorExperienceEnabled(state),
  };
}

export default connect(mapStateToProps)(ContentSection);
